import { render, staticRenderFns } from "./add-level.vue?vue&type=template&id=142050e1&scoped=true&"
import script from "./add-level.vue?vue&type=script&lang=js&"
export * from "./add-level.vue?vue&type=script&lang=js&"
import style0 from "./add-level.vue?vue&type=style&index=0&id=142050e1&lang=scss&scoped=true&"
import style1 from "./add-level.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142050e1",
  null
  
)

export default component.exports